import { useEffect, useState } from "react"

import classes from './TotalCharges.module.css'
import { formatCurrency } from "../../../../lib/script"

const Totals = ({practices, label, identifier}) => {

    const [total, setTotal] = useState(null)

    useEffect(() => {
        if (practices && practices.length> 0) {
            const sumWithInitial = practices.reduce(function (acc, obj) { return acc + Number(obj[identifier]) }, 0)

            setTotal(sumWithInitial)
        }
    }, [practices])
    
    return <div className={classes.item}>
        <div className={classes.label}>{label}</div>
        <div className={classes.sum}>${formatCurrency(total)}</div>
    </div>
}

export default Totals